import styles from './style.postcss';

import React from 'react';
import RadialProgress from 'react-radial-progress';
import is from 'is_js';
import PropTypes from 'prop-types';

const isScoreInInclusiveRange = (percent, start, end) =>
  percent >= start && (percent < end || ! is.number(end));

const getColorForScore = (percent) => {
  const _isScoreInRangeInclusive = isScoreInInclusiveRange.bind(this, percent);
  if (_isScoreInRangeInclusive(0, 60)) return styles.colorExperiencingDifficulty;
  if (_isScoreInRangeInclusive(60, 70)) return styles.colorNeedsImprovement;
  if (_isScoreInRangeInclusive(70, 80)) return styles.colorOnTrack;
  if (_isScoreInRangeInclusive(80, 90)) return styles.colorStrong;
  if (_isScoreInRangeInclusive(90)) return styles.colorOutstanding;
  return styles.colorUnknown;
};

const RadialScoreDisplay = (props) => {
  let color = styles.colorUnknown;
  const value = is.number(props.percent) ? props.percent : props.value;
  if (is.number(props.percent) || props.unit === 'percent') {
    color = getColorForScore(value);
  }
  return <div className={props.className}>
    <RadialProgress {...props}
        progressStroke={color}
        value={props.percent || props.value} />
  </div>;
};

RadialScoreDisplay.propTypes = {
  unit: PropTypes.string,
  value: PropTypes.number,
  percent: PropTypes.number,
  className: PropTypes.string,
};

export default RadialScoreDisplay;



// WEBPACK FOOTER //
// ./components/RadialScoreDisplay/index.jsx